export type ConnectionStation = {
  id: string; name: string; location_id: string; enabled: boolean; config_version?: number;
  last_seen?: string | null; firmware?: string | null; device_info?: { chipMac?: string };
};
export type StationArea = { id: string; name: string; enabled: boolean };
export type StationTask = { id: string; gateway_id: string; state: string; source_code?: string | null };

export function stationConnection(station: ConnectionStation, stale = false, now = Date.now()) {
  if (!station.enabled) return { label: 'Đang khóa', tone: 'muted' };
  if (stale) return { label: 'Chưa cập nhật được trạng thái', tone: 'warning' };
  if (!station.last_seen) return { label: 'Chưa kết nối lần nào', tone: 'muted' };
  const age = now - Date.parse(station.last_seen);
  return Number.isFinite(age) && age >= -5000 && age < 60_000
    ? { label: 'Đang kết nối', tone: 'online' }
    : { label: 'Mất liên lạc', tone: 'warning' };
}

export function stationMoveBlocker(stationId: string, tasks: StationTask[]) {
  const pending = tasks.find(task => task.gateway_id === stationId && ['LEASED', 'RECEIVED', 'SENDING', 'UNKNOWN'].includes(task.state));
  if (!pending) return null;
  return pending.state === 'UNKNOWN'
    ? 'Có yêu cầu cần kiểm tra nhãn trên giấy. Xử lý trong Lịch sử in trước khi chuyển.'
    : 'Trạm đang xử lý yêu cầu. Đợi thao tác kết thúc trước khi chuyển.';
}

export function stationDestinations(station: ConnectionStation, areas: StationArea[]) {
  return areas.filter(area => area.enabled && area.id !== station.location_id);
}

export function stationMoveRequest(station: ConnectionStation, areaId: string, areas: StationArea[]) {
  if (!stationDestinations(station, areas).some(area => area.id === areaId)) throw new Error('Chọn một khu vực mới đang hoạt động.');
  // Keep the stored name, identity and token. Moving never registers a new board.
  return { path: `/printing/gateways/${station.id}/configure`, body: { name: station.name, locationId: areaId } };
}
